export default {
  // Inventory
  "no_films_found": "No se encontraron películas que coincidan con",
  "no_films_yet": "Aún no tienes ningún rollo de película",
  "add_first_film": "Añade Tu Primera Película",
  "no_lenses_found": "No se encontraron lentes que coincidan con",
  "no_lenses_yet": "Aún no tienes ningún lente",
  "add_first_lens": "Añade Tu Primer Lente",
  "no_cameras_found": "No se encontraron cámaras que coincidan con",
  "no_cameras_yet": "Aún no tienes ninguna cámara",
  "add_first_camera": "Añade Tu Primera Cámara",
  "no_items_inventory": "No hay elementos en tu inventario",
  "inventory_management": "Gestión de Inventario",
  "film": "Película",
  "cameras": "Cámaras",
  "lenses": "Lentes",
  "search_films": "Buscar películas...",
  "search_lenses": "Buscar lentes...",
  "search_cameras": "Buscar cámaras...",
  "add_lens": "Añadir Lente",
  "add_film": "Añadir Película",
  "add_camera": "Añadir Cámara",
  "add_new_lens": "Añadir Nuevo Lente",
  "add_new_film": "Añadir Nueva Película",
  "add_new_camera": "Añadir Nueva Cámara",
  "add_lens_details": "Completa los detalles a continuación para añadir un nuevo lente a tu inventario.",
  "add_film_details": "Completa los detalles a continuación para añadir una nueva película a tu inventario.",
  "add_camera_details": "Completa los detalles a continuación para añadir una nueva cámara a tu inventario.",
  "essential_info": "Información Esencial",
  "optional_details": "Detalles Opcionales",
  "brand": "Marca",
  "lens_name": "Nombre/Modelo del Lente",
  "lens_name_placeholder": "50mm f/1.8, 24-70mm f/2.8, etc.",
  "brand_placeholder": "Nikon, Canon, etc.",
  "film_name": "Nombre de la Película",
  "film_name_placeholder": "Portra 400, HP5 Plus, etc.",
  "camera_name": "Nombre/Modelo de la Cámara",
  "camera_name_placeholder": "AE-1, F3, Leica M6, etc.",
  "mount": "Montura",
  "mount_placeholder": "ej. EF, M42",
  "mount_description": "Máximo 4 caracteres alfanuméricos (ej. EF, M42)",
  "status": "Estado",
  "select_status": "Seleccionar estado",
  "working": "Funcionando",
  "needs_repair": "Necesita Reparación",
  "for_parts": "Para Repuestos",
  "serial_number": "Número de Serie (Opcional)",
  "purchase_date": "Fecha de Compra (Opcional)",
  "purchase_price": "Precio de Compra (Opcional)",
  "notes": "Notas (Opcional)",
  "notes_placeholder": "Cualquier nota adicional sobre este artículo",
  "next_step": "Siguiente Paso",
  "update_lens": "Actualizar Lente",
  "update_film": "Actualizar Película",
  "update_camera": "Actualizar Cámara",
  "edit_film": "Editar Película",
  "edit_lens": "Editar Lente",
  "edit_camera": "Editar Cámara",
  "update_film_details": "Actualiza los detalles de tu película a continuación",
  "update_lens_details": "Actualiza los detalles de tu lente a continuación",
  "update_camera_details": "Actualiza los detalles de tu cámara a continuación",
  "delete_film": "Eliminar Película",
  "delete_lens": "Eliminar Lente",
  "delete_camera": "Eliminar Cámara",
  "confirm_delete_film": "¿Estás seguro de que quieres eliminar",
  "confirm_delete_lens": "¿Estás seguro de que quieres eliminar",
  "confirm_delete_camera": "¿Estás seguro de que quieres eliminar",
  "from_your_inventory": "de tu inventario",
  "action_cannot_undone": "Esta acción no se puede deshacer.",
  "film_removed_inventory": "Película eliminada del inventario",
  "lens_removed_inventory": "Lente eliminado del inventario",
  "camera_removed_inventory": "Cámara eliminada del inventario",
  "failed_delete_film": "Error al eliminar la película",
  "failed_delete_lens": "Error al eliminar el lente",
  "failed_delete_camera": "Error al eliminar la cámara",
  "cannot_delete_film_missing_id": "No se puede eliminar la película, falta ID",
  "cannot_delete_lens_missing_id": "No se puede eliminar el lente, falta ID",
  "cannot_delete_camera_missing_id": "No se puede eliminar la cámara, falta ID",
  "film_updated_successfully": "Película actualizada con éxito",
  "lens_updated_successfully": "Lente actualizado con éxito",
  "camera_updated_successfully": "Cámara actualizada con éxito",
  "error_updating_film": "Error al actualizar la película",
  "error_updating_lens": "Error al actualizar el lente",
  "error_updating_camera": "Error al actualizar la cámara",
  "cannot_update_film_missing_id": "No se puede actualizar la película, falta ID",
  "cannot_update_lens_missing_id": "No se puede actualizar el lente, falta ID",
  "cannot_update_camera_missing_id": "No se puede actualizar la cámara, falta ID",
  "all": "Todos",
  "all_film": "Todas las Películas",
  "all_lenses": "Todos los Lentes",
  "all_cameras": "Todas las Cámaras",
  "unexposed": "Sin Exponer",
  "fresh": "Nuevo",
  "exposed": "Expuesta",
  "expired": "Caducada",
  "developed": "Revelada",
  "transferring": "Transfiriendo:",
  "quantity_expose": "Cantidad a exponer",
  "notes_optional": "Notas (opcional)",
  "mark_exposed": "Marcar como Expuesta",
  "mark_film_exposed": "Marcar Película como Expuesta",
  "transfer_film_description": "Transferir película de tu inventario a tu colección de expuestas.",
  "signin_required_inventory": "Debes iniciar sesión para ver tu inventario",
  "film_details": "Detalles de la Película",
  "lens_details": "Detalles del Lente",
  "camera_details": "Detalles de la Cámara",
  "last_updated": "Última actualización",
  "type": "Tipo",
  "quantity": "Cantidad",
  "expiration_date": "Fecha de Caducidad",
  "expiration": "Caducidad",
  "focal_length": "Distancia Focal",
  "aperture": "Apertura",
  "iso": "ISO",
  "film_type": "Tipo de Película",
  "color": "Color",
  "black_and_white": "Blanco y Negro",
  "slide": "Diapositiva",
  "camera_type": "Tipo de Cámara",
  "slr": "SLR",
  "dslr": "DSLR",
  "mirrorless": "Sin Espejo",
  "rangefinder": "Telémetro",
  "point_and_shoot": "Apuntar y Disparar",
  "instant_film": "Película Instantánea",
  "error_loading_cameras": "Error al cargar cámaras",
  "camera_added_successfully": "Cámara añadida con éxito",
  "error_adding_camera": "Error al añadir cámara",
  "adapter_enabled": "Adaptador activado",
  "adapter_mounts": "Monturas de adaptador",
  "compatible_cameras": "Cámaras compatibles",
  "compatible_lenses": "Lentes compatibles",
  "compatible_films": "Películas compatibles",
  "are_you_absolutely_sure": "¿Estás absolutamente seguro?",
  "select_format": "Seleccionar formato",
  "select_camera_type": "Seleccionar tipo de cámara",
  "model": "Modelo",
  "medium_format": "Formato Medio",
  "large_format": "Formato Grande",
  "format": "Formato",
};
